/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DataChartPieA1Icon20Regular = forwardRef('DataChartPieA1Icon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 2.001a.75.75 0 0 0-.75.75v7.25a.75.75 0 0 0 1.125.649l6.278-3.623a.75.75 0 0 0 .275-1.025 7.999 7.999 0 0 0-6.928-4Zm.75 6.7V3.545a6.499 6.499 0 0 1 4.466 2.58L10.75 8.7Z" }),
        React.createElement("path", { d: "M7.186 4.142a.75.75 0 0 0-.65-1.352 7.999 7.999 0 1 0 11.447 6.707.75.75 0 0 0-1.497.095 6.5 6.5 0 1 1-9.3-5.45Z" })));
});
